import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/roboto-regular-webfont.woff2%22,%22variable%22:%22--font-roboto%22}],%22variableName%22:%22roboto%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'roboto', 'roboto Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
